<template>
    <div class="home">
        <!-- 首图banner -->
        <div class="home-swipe">
            <van-swipe :autoplay="3000" lazy-render>
                <van-swipe-item class="home-swipe__item" v-for='(image, index) in bannerImageList' :key='index'>
                    <van-image :src='image' fit="cover"/>
                </van-swipe-item>
            </van-swipe>
        </div>
        <van-search 
            v-model="keyword" 
            placeholder="请输入搜索关键词" 
            @search="onSearch"
            @cancel="onCancel"
            @clear="onCancel"
            show-action
        >
            <template #action>
                <div @click="onSearch">搜索</div>
            </template>
        </van-search>
        <div class="home__tree-select-wrapper">
            <van-tree-select
                :items="itemList"
                :main-active-index.sync="mainActiveIndex"
                @click-nav="clickNav" 
                class="home__tree-select"
            >
                <template #content>
                    <div class="tree-select__sku-item-wrapper">
                        <van-row
                            v-for="item in (itemList[mainActiveIndex] ? itemList[mainActiveIndex].children : [])"
                            :key="item.id"
                            @click="goToSku(item.id)"
                            type="flex"
                            justify="space-between"
                            align="center"
                            class="tree-select__sku-item"
                        >
                            <!-- 商品图 -->
                            <van-col span="8">
                                <van-image :src="item.coverPic" width="72" height="72"/>
                            </van-col>
                            <!-- 商品信息 -->
                            <van-col span="16">
                                <!-- 商品名 -->
                                <van-row class="tree-select__sku-name van-multi-ellipsis--l2">{{item.skuName}}</van-row>
                                <!-- 商品价格、下单按钮 -->
                                <van-row
                                    type="flex"
                                    justify="space-between"
                                    align="bottom" 
                                >
                                    <!-- 商品现价、原价 -->
                                    <van-col class="tree-select__price-button" type="flex" justify="space-between" align="space-between">
                                        <van-col>
                                            <!-- 现价 -->
                                            <span class="tree-select__sku-disc-price">¥ {{fen2Yuan(item.discPrice)}}</span>
                                            <!-- 原价 -->
                                            <span class="tree-select__sku-raw-price">¥ {{fen2Yuan(item.rawPrice)}}</span>
                                        </van-col>

                                    </van-col> 
                                    <!-- 去下单 -->
                                    <van-col class="tree-select__sku-button">
                                        <van-button hairline round type="primary" size="mini">选购</van-button> 
                                    </van-col>
                                </van-row>
                            </van-col>
                        </van-row>
                    </div>
                </template>
            </van-tree-select>
        </div>
        
        <!-- 骨架屏 -->
        <div class="home__skeleton-wrapper" v-if="loading">
            <van-row class="home-swipe__skeleton-wrapper">
                <div class="home-swipe__skeleton"></div>
            </van-row>
            <van-row
                class="home-content__skeleton-wrapper"
                type="flex" 
            >
                <van-row
                    class="home__skeleton-nav-wrapper"
                >
                    <van-col class="home__skeleton-nav-item"></van-col>
                    <van-col class="home__skeleton-nav-item"></van-col>
                    <van-col class="home__skeleton-nav-item"></van-col>
                    <van-col class="home__skeleton-nav-item"></van-col>
                    <van-col class="home__skeleton-nav-item"></van-col>
                </van-row>
                <van-row
                    class="home__skeleton-content-wrapper"
                >
                    <van-row class="home__skeleton-content-item-wrapper" type="flex">
                        <van-col class="home__skeleton-content-item-avatar" span="7"/>
                        <van-col class="home__skeleton-content-info-wrapper" span="10">
                            <van-row class="home__skeleton-content-info"/>
                            <van-row class="home__skeleton-content-info"/>
                        </van-col>
                    </van-row>

                     <van-row class="home__skeleton-content-item-wrapper" type="flex">
                        <van-col class="home__skeleton-content-item-avatar" span="7"/>
                        <van-col class="home__skeleton-content-info-wrapper" span="10">
                            <van-row class="home__skeleton-content-info"/>
                            <van-row class="home__skeleton-content-info"/>
                        </van-col>
                    </van-row>

                   <van-row class="home__skeleton-content-item-wrapper" type="flex">
                        <van-col class="home__skeleton-content-item-avatar" span="7"/>
                        <van-col class="home__skeleton-content-info-wrapper" span="10">
                            <van-row class="home__skeleton-content-info"/>
                            <van-row class="home__skeleton-content-info"/>
                        </van-col>
                    </van-row>

                    <van-row class="home__skeleton-content-item-wrapper" type="flex">
                        <van-col class="home__skeleton-content-item-avatar" span="7"/>
                        <van-col class="home__skeleton-content-info-wrapper" span="10">
                            <van-row class="home__skeleton-content-info"/>
                            <van-row class="home__skeleton-content-info"/>
                        </van-col>
                    </van-row>
                
                </van-row>
            </van-row>
        </div>
    </div>    
</template>

<script>
import {Col, Row, Swipe, SwipeItem,
Image, TreeSelect, Skeleton, Button, Sticky, Search } from "vant";
import {navMixins} from "@/mixins.js";
import request from "@/utils/request.js";

export default {
    name: "StarbucksHome",
    mixins: [navMixins],
    components: {
        [Search.name]: Search,
        [Col.name]: Col,
        [Row.name]: Row,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Image.name]: Image,
        [TreeSelect.name]: TreeSelect,
        [Skeleton.name]: Skeleton,
        [Button.name]: Button,
        [Sticky.name]: Sticky
    },
    data() {
        return {
            bannerImageList: [],
            skuTagList: [],
            mainActiveIndex: 0,
            loading: true,
            keyword: undefined
        };
    },
    computed: {
        itemList() {
            if (this.skuTagList && this.skuTagList.length > 0) {
                
                const result = this.skuTagList.map(skuTag => {
                    return {
                        text: skuTag.tag,
                        tagCode: skuTag.tagCode,
                        children: skuTag.skuList.map(sku => {
                            return sku;
                        })
                    };
                });
                return result;
            }
            return [];
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        onCancel() {
            this.keyword = undefined
        },
        onSearch() {
            this.init();
        },
        clickNav() {
            console.log(this.mainActiveIndex);
        },
        async init() {
            const {response, data} = await request.post('/customer/home/starbucksHomeInfo', {
                data: {
                    keyword: this.keyword
                }
            });
            if (response.ok) {
                this.bannerImageList = data.bannerImgList;
                this.skuTagList = data.tagSkuList
            }
            this.loading = false;
        },
        fen2Yuan(fen) {
            return (fen / 100).toFixed(2);
        },
        goToSku(skuId) {
            this.$router.push(`sku/${skuId}`);
        }
    }
}
</script>

<style lang="less">
@import "@/style/base.less";

.home {
    height: calc(100vh - 50px);

    .van-sidebar-item--select::before {
        border-radius: 2px;
        background-color: @color-theme;
    }

    div.van-image {
        display: block;
    }
}

// Skeleton 样式
.home__skeleton-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    padding: 8px;
    box-sizing: border-box;
    background-color: @color-skeleton-background;
}

.home-swipe__skeleton-wrapper {
    height: 150px;
    box-sizing: border-box;
    margin-bottom: 8px;
}

.home-content__skeleton-wrapper {
    height: calc(100vh - 150px - 50px);
}

.home-swipe__skeleton {
    height: 100%;
    background-color: @color-skeleton-placeholder;
    border-radius: @border-radius-small;
}

.home__skeleton-nav-wrapper {
    flex: 2;
    background-color: @color-skeleton-background;
    height: calc(100vh - 150px);
    box-sizing: border-box;
    margin-right: 8px;
    margin-top: 16px;
}

.home__skeleton-nav-item {
    background-color: @color-skeleton-placeholder;
    border-radius: @border-radius-small;
    height: 16px;
    width: 100%;

    margin-top: 16px;

    &:first-child {
        margin-top: 0px;
    }
}

.home__skeleton-content-wrapper {
    background-color: @color-skeleton-background;
    flex: 7;
    box-sizing: border-box;
    margin-top: 16px;
    padding: 0 8px;
    overflow: hidden;
}
.home__skeleton-content-item-wrapper {
    margin-top: 8px;

    &:first-child {
        margin-top: 0px;
    }
}

.home__skeleton-content-item-avatar {
    width: 72px;
    height: 72px;
    border-radius: 36px;
    background-color: @color-skeleton-placeholder;
}

.home__skeleton-content-info-wrapper {
    padding-left: 8px;
}

.home__skeleton-content-info {
    height: 16px;
    width: 100%;
    border-radius: @border-radius-small;
    background-color: @color-skeleton-placeholder; 
    margin-top: 20px;

    &:first-child {
        margin-top: 8px;
    }
}

.home__skeleton-content-item {
    background-color: @color-skeleton-placeholder;
    height: 36px;;
    border-radius: @border-radius-small;

    margin-top: 8px;
    
    &:first-child {
        margin-top: 0px;
    }
}


// Skeleton
.home__tree-select {
    height: 100vh!important;
    padding-bottom: calc(50px + env(safe-area-inset-bottom));
    padding-bottom: calc(50px + constant(safe-area-inset-bottom));
    box-sizing: border-box;
}

.home__tree-select .van-tree-select__nav {
    flex: 2;
    -webkit-box-flex: 2;
}

.home__tree-select .van-tree-select__content {
    flex: 5;
    -webkit-box-flex: 5;
}

.tree-select__sku-item-wrapper {
    padding: 8px;
}

.tree-select__sku-button {
    .van-button--primary {
        background: @color-vice;
        border: 1px solid @color-vice;
        color: @color-theme;
    }
}

.tree-select__sku-item {
    &:first-child {
        margin-top: 0px;
    }
    margin-top: 8px;

    .van-button--mini {
        height: 20px;
        padding: 6px 10px;
        font-size: @font-size-mini;
    }
}

.tree-select__sku-name {
    font-size: @font-size-title;
    color: @font-color-title;
    line-height: @line-height-title;
}

.tree-select__price-button {
    margin-top: 16px;
}

.tree-select__sku-disc-price {
    color: @color-price;
    font-weight: @font-weight-price;
    line-height: @line-height-title;
    word-spacing: normal;
    font-size: @font-size-title;
}

.tree-select__sku-raw-price {
    color: @font-color-secondary;
    font-size: @font-size-mini;
    line-height: @line-height-mini;
    font-weight: @font-weight-normal;
    text-decoration: line-through;
    vertical-align: bottom;
    word-spacing: normal;
    padding-left: 8px;
}
</style>